// extracted by mini-css-extract-plugin
module.exports = {"dataRow":"styles_dataRow__3biwA","dataColunmTitle":"styles_dataColunmTitle__q4Kiu","dataColunmInfo":"styles_dataColunmInfo__20WJb","nenhumDado":"styles_nenhumDado__ZPH5I"};